module.exports = __webpack_public_path__ + "img/9791155310779.6dc057a8.jpg";